export const localPaths = {
    home: '',
    patterns: 'patterns',
    pattern: 'pattern',
};
